
export default function Collaborations() {
  return (
    <section className="py-24 px-6 relative">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-purple-400 mb-8">
            Collaborations
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-emerald-400 to-purple-400 mx-auto mb-8"></div>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Connect with top influencers and participate in exclusive events that elevate your streaming career.
          </p>
        </div>

        {/* Collaboration Features */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 p-8 rounded-3xl border border-gray-700/50">
            <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-purple-500 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-live-fill text-2xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">Collab Streams</h3>
            <p className="text-gray-300 mb-6">
              Join forces with other PSU streamers for high-energy collaboration streams that boost everyone's audience.
            </p>
            <div className="space-y-3">
              <div className="flex items-center">
                <i className="ri-check-line text-emerald-400 mr-3"></i>
                <span className="text-gray-200">Weekly collab opportunities</span>
              </div>
              <div className="flex items-center">
                <i className="ri-check-line text-emerald-400 mr-3"></i>
                <span className="text-gray-200">Cross-platform promotion</span>
              </div>
              <div className="flex items-center">
                <i className="ri-check-line text-emerald-400 mr-3"></i>
                <span className="text-gray-200">Shared audience growth</span>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 p-8 rounded-3xl border border-gray-700/50">
            <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-emerald-500 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-trophy-fill text-2xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">Community Events</h3>
            <p className="text-gray-300 mb-6">
              Participate in PSU-hosted events, tournaments, and challenges that bring the community together.
            </p>
            <div className="space-y-3">
              <div className="flex items-center">
                <i className="ri-check-line text-emerald-400 mr-3"></i>
                <span className="text-gray-200">Monthly tournaments</span>
              </div>
              <div className="flex items-center">
                <i className="ri-check-line text-emerald-400 mr-3"></i>
                <span className="text-gray-200">Special event rewards</span>
              </div>
              <div className="flex items-center">
                <i className="ri-check-line text-emerald-400 mr-3"></i>
                <span className="text-gray-200">Community recognition</span>
              </div>
            </div>
          </div>
        </div>

        {/* Upcoming Events */}
        <div className="bg-gradient-to-r from-emerald-500/10 to-purple-500/10 p-8 rounded-3xl border border-emerald-500/20">
          <div className="text-center mb-8">
            <h3 className="text-3xl font-bold text-white mb-4">Upcoming Events</h3>
            <p className="text-gray-300">Don't miss these exciting collaboration opportunities</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-slate-800/50 p-6 rounded-2xl border border-gray-700/50">
              <div className="text-emerald-400 font-bold text-sm mb-2">THIS WEEKEND</div>
              <h4 className="text-xl font-bold text-white mb-2">PSU Pump Challenge</h4>
              <p className="text-gray-300 text-sm mb-4">24-hour streaming marathon with special rewards</p>
              <div className="flex items-center text-sm text-gray-400">
                <i className="ri-calendar-line mr-2"></i>
                <span>Dec 15-16</span>
              </div>
            </div>

            <div className="bg-slate-800/50 p-6 rounded-2xl border border-gray-700/50">
              <div className="text-purple-400 font-bold text-sm mb-2">NEXT WEEK</div>
              <h4 className="text-xl font-bold text-white mb-2">Collab Stream Night</h4>
              <p className="text-gray-300 text-sm mb-4">Multi-streamer collaboration event</p>
              <div className="flex items-center text-sm text-gray-400">
                <i className="ri-calendar-line mr-2"></i>
                <span>Dec 22</span>
              </div>
            </div>

            <div className="bg-slate-800/50 p-6 rounded-2xl border border-gray-700/50">
              <div className="text-emerald-400 font-bold text-sm mb-2">MONTHLY</div>
              <h4 className="text-xl font-bold text-white mb-2">Dean's Roundtable</h4>
              <p className="text-gray-300 text-sm mb-4">Exclusive Q&A with top performers</p>
              <div className="flex items-center text-sm text-gray-400">
                <i className="ri-calendar-line mr-2"></i>
                <span>Last Friday</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
